import React from "react";
import {
  Snackbar,
  IconButton,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';


const ClaimNote = ({
  message, open, handleClose
}) => {
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message={message}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
}

export { ClaimNote };
